import { render, staticRenderFns } from "./DeclareAll.vue?vue&type=template&id=1896a28a&"
import script from "./DeclareAll.vue?vue&type=script&lang=js&"
export * from "./DeclareAll.vue?vue&type=script&lang=js&"
import style0 from "./DeclareAll.vue?vue&type=style&index=0&id=1896a28a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports